import React, { useState } from 'react';
const faqs = [{
  q: '¿Necesito un horno especial?',
  a: 'No. Todo está diseñado para hornos domésticos. Aprenderás el truco de la bandeja invertida que replica una piedra volcánica.'
}, {
  q: '¿Dónde consigo la harina "00"?',
  a: 'Incluimos equivalencias exactas para Argentina, México, España, Colombia, Chile y EE.UU.'
}, {
  q: '¿Cuándo recibo el material?',
  a: 'Acceso inmediato. Segundos después del pago recibirás el link de descarga (PDF + Excel).'
}, {
  q: '¿Sirve si soy principiante?',
  a: 'Sí. El Tomo 1 comienza desde cero con un plan de 7 días paso a paso.'
}, {
  q: '¿Puedo usarlo para un negocio?',
  a: 'Absolutamente. Las 50 recetas te dan una carta completa lista para explotar comercialmente.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(null);
  return <div className="bg-[#111111] border-t border-b border-[#C0392B]/20 py-6 px-5" data-id="element-22">
      <div className="max-w-3xl mx-auto" data-id="element-23">
        <h2 className="font-serif text-xl sm:text-2xl text-[#C0392B] text-center mb-1 uppercase tracking-wider" data-id="element-24">
          Preguntas Frecuentes
        </h2>
        <div className="w-16 h-0.5 bg-gradient-to-r from-[#C0392B] to-[#F1C40F] mx-auto rounded my-2" data-id="element-25" />

        <div className="flex flex-col gap-2 mt-4" data-id="element-26">
          {faqs.map((faq, i) => <div key={i} className="bg-[#1A1A1A] border border-[#C0392B]/25 rounded-lg overflow-hidden" data-id="element-27">
              <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-center justify-between p-3 text-left cursor-pointer" data-id="element-28">
                <span className="text-[#F1C40F] text-xs sm:text-sm font-serif font-bold" data-id="element-29">
                  ❓ {faq.q}
                </span>
                <span className="text-[#F1C40F] text-lg ml-2 flex-shrink-0" data-id="element-30">
                  {open === i ? '−' : '+'}
                </span>
              </button>
              {open === i && <div className="px-3 pb-3" data-id="element-31">
                  <p className="text-[#AAAAAA] text-[11px] leading-relaxed" data-id="element-32">
                    {faq.a}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </div>;
}